import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit-element/lit-element.js';
import { ifDefined } from '../../node_modules/lit-html/directives/if-defined.js';
import customElement from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/decorators/custom-element.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdBaseComponent } from '../pvd-base-component/pvd-base-component.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';
import { html } from '../../node_modules/lit-html/lit-html.js';
import { ScopedElementsMixin } from '../../node_modules/@open-wc/scoped-elements/src/ScopedElementsMixin.js';
import { query, property } from '../../node_modules/lit-element/lib/decorators.js';

var DEFAULT_DISABLED = false;
var DEFAULT_ERROR = false;
var DEFAULT_FULL_WIDTH = false;
var DEFAULT_REQUIRED = false;
var DEFAULT_SIZE = StandardSize.medium;
var SELECT_PROTECTED_ATTR_MAP = new Map([
    ['aria-describedby', 'pvd-aria-describedby'],
    ['aria-disabled', 'pvd-disabled'],
    ['aria-invalid', 'pvd-error'],
    ['aria-required', 'pvd-required'],
    ['aria-label', 'pvd-aria-label'],
    ['disabled', 'pvd-disabled'],
    ['id', 'pvd-id'],
    ['required', 'pvd-required'],
]);
/**
 * Providence Select component.
 * @see {@link https://providence.fmr.com/components/select/select.html|Select documentation}
 */
var CustomElementMixin = customElement({
    name: 'select',
    namespace: 'pvd',
});
var PvdSelect = /** @class */ (function (_super) {
    __extends(PvdSelect, _super);
    function PvdSelect() {
        // #region LitElement properties
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdDisabled = DEFAULT_DISABLED;
        _this.pvdError = DEFAULT_ERROR;
        _this.pvdFullWidth = DEFAULT_FULL_WIDTH;
        _this.pvdRequired = DEFAULT_REQUIRED;
        _this.pvdSize = DEFAULT_SIZE;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdSelect, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                's-slot': customElements.get('s-slot'),
                // @ts-ignore
                'pvd-scoped-icon': customElements.get(this.namespace + "-icon"),
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PvdSelect.prototype, "iconSize", {
        // #endregion
        // #region private methods
        get: function () {
            return this.pvdSize === StandardSize.large ? Size.medium : Size.small;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets attributes on the select element that are coming from pvdNativeselectAttributes
     * @param prevAttr optional, if user updates pvdNativeSelectAttributes, this will remove/update existing attributes
     */
    PvdSelect.prototype.setNativeSelectAttributes = function (prevAttr) {
        this.setNativeAttributes(this.pvdNativeSelectAttributes, SELECT_PROTECTED_ATTR_MAP, this._nativeSelectEl, prevAttr);
    };
    /**
     * On first render, if pvdSelectedValue does not exist, set it to the option in the selectedIndex
     * Needed to correctly set `aria-label` to the selected option for proper readout on NVDA+FF
     */
    PvdSelect.prototype.setSelectedValue = function () {
        this.pvdSelectedValue =
            this._nativeSelectEl.options.length > 0
                ? this._nativeSelectEl.options[this._nativeSelectEl.options.selectedIndex].value
                : undefined;
    };
    // #endregion
    // #region events
    /**
     * Update the `pvdSelectedValue` property to match the new value of the <select> element
     * @param e
     */
    PvdSelect.prototype.onChange = function (e) {
        this.pvdSelectedValue = e.target.value;
    };
    // #endregion
    // #region LitElement lifecycles
    PvdSelect.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (!this.pvdSelectedValue) {
            this.setSelectedValue();
        }
        if (this.pvdNativeSelectAttributes) {
            var prevAttr = changedProperties.get('pvdNativeSelectAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeSelectAttributes(prevAttr);
        }
    };
    // iterates through the pvdOptions array and determines if each object is a single option or an option group
    PvdSelect.prototype.renderOptions = function () {
        var _this = this;
        return html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
            "\n    "])), this.pvdOptions
            ? this.pvdOptions.map(function (option) {
                return html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                ", "\n              "], ["\n                ",
                    "\n              "])), option.label
                    ? _this.renderOptGroup(option)
                    : _this.renderOption(option));
            })
            : '');
    };
    // renders a single option group
    PvdSelect.prototype.renderOptGroup = function (optGroup) {
        var _this = this;
        return html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      <optgroup label=\"", "\">\n        ", "\n      </optgroup>\n    "], ["\n      <optgroup label=\"", "\">\n        ", "\n      </optgroup>\n    "])), optGroup.label, optGroup.options.map(function (option) { return html(templateObject_3 || (templateObject_3 = __makeTemplateObject([" ", " "], [" ", " "])), _this.renderOption(option)); }));
    };
    // renders a single option
    PvdSelect.prototype.renderOption = function (option) {
        // Checking for `option.value == undefined` allows for an empty string to be
        // provided as an option's value. If we didn't check for undefined, an empty
        // string would be replaced by `option.text`.
        var value = option.value == undefined ? option.text : option.value;
        var selected = this.pvdSelectedValue && this.pvdSelectedValue === value ? true : undefined;
        var ariaLabel = selected ? option.text : undefined;
        return html(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
            "\n    "])), option.text
            ? html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            <option\n              aria-label=\"", "\"\n              value=\"", "\"\n              ?disabled=\"", "\"\n              ?selected=\"", "\"\n            >\n              ", "\n            </option>\n          "], ["\n            <option\n              aria-label=\"", "\"\n              value=\"", "\"\n              ?disabled=\"", "\"\n              ?selected=\"", "\"\n            >\n              ", "\n            </option>\n          "])), ifDefined(ariaLabel), value, ifDefined(option.disabled), ifDefined(selected), option.text) : '');
    };
    // renders the caret icon in the select
    PvdSelect.prototype.renderSelectIcon = function () {
        return html(templateObject_7 || (templateObject_7 = __makeTemplateObject(["<pvd-scoped-icon\n      pvd-icon-class=\"pvd-select__icon\"\n      pvd-name=\"action__caret-down\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"], ["<pvd-scoped-icon\n      pvd-icon-class=\"pvd-select__icon\"\n      pvd-name=\"action__caret-down\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"])), this.iconSize);
    };
    PvdSelect.prototype.render = function () {
        var classMap = {
            // @ts-ignore
            default: this.constructor.namespace + "-select-root",
            modifierPrefix: 'pvd-select',
            modifiers: [
                {
                    condition: this.pvdDisabled,
                    className: 'disabled',
                },
                {
                    condition: this.pvdError,
                    className: 'error',
                },
                {
                    condition: this.pvdFullWidth,
                    className: 'full-width',
                },
                {
                    condition: true,
                    className: "" + this.pvdSize,
                },
            ],
        };
        return html(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      <div class=\"", "\">\n        <div class=\"pvd-select__wrapper\">\n          <select\n            @blur=", "\n            @change=", "\n            @focus=", "\n            ?disabled=\"", "\"\n            ?required=\"", "\"\n            aria-describedby=\"", "\"\n            aria-disabled=\"", "\"\n            aria-invalid=\"", "\"\n            aria-label=\"", "\"\n            aria-required=\"", "\"\n            class=\"pvd-select__select\"\n            id=\"", "\"\n            .value=\"", "\"\n          >\n            ", "\n          </select>\n          ", "\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\">\n        <div class=\"pvd-select__wrapper\">\n          <select\n            @blur=", "\n            @change=", "\n            @focus=", "\n            ?disabled=\"", "\"\n            ?required=\"", "\"\n            aria-describedby=\"", "\"\n            aria-disabled=\"", "\"\n            aria-invalid=\"", "\"\n            aria-label=\"", "\"\n            aria-required=\"", "\"\n            class=\"pvd-select__select\"\n            id=\"", "\"\n            .value=\"", "\"\n          >\n            ", "\n          </select>\n          ", "\n        </div>\n      </div>\n    "])), getClassName(classMap), this.bubbleEvent, this.onChange, this.bubbleEvent, this.pvdDisabled, this.pvdRequired, ifDefined(this.pvdAriaDescribedby), ifDefined(this.a11yBoolean(this.pvdDisabled)), ifDefined(this.a11yBoolean(this.pvdError)), ifDefined(this.pvdAriaLabel), ifDefined(this.a11yBoolean(this.pvdRequired)), ifDefined(this.pvdId), this.pvdSelectedValue, this.renderOptions(), this.renderSelectIcon());
    };
    __decorate([
        query('.pvd-select__select'),
        __metadata("design:type", HTMLSelectElement)
    ], PvdSelect.prototype, "_nativeSelectEl", void 0);
    __decorate([
        property({
            type: String,
            reflect: true,
            attribute: 'pvd-aria-describedby',
        }),
        __metadata("design:type", String)
    ], PvdSelect.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
        __metadata("design:type", String)
    ], PvdSelect.prototype, "pvdAriaLabel", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disabled' }, PvdBaseComponent.booleanAttribute('pvd-disabled'))),
        __metadata("design:type", Boolean)
    ], PvdSelect.prototype, "pvdDisabled", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-error' }, PvdBaseComponent.booleanAttribute('pvd-error'))),
        __metadata("design:type", Boolean)
    ], PvdSelect.prototype, "pvdError", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-full-width' }, PvdBaseComponent.booleanAttribute('pvd-full-width'))),
        __metadata("design:type", Boolean)
    ], PvdSelect.prototype, "pvdFullWidth", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-id' }),
        __metadata("design:type", String)
    ], PvdSelect.prototype, "pvdId", void 0);
    __decorate([
        property({ type: Object, attribute: 'pvd-native-select-attributes' }),
        __metadata("design:type", Object)
    ], PvdSelect.prototype, "pvdNativeSelectAttributes", void 0);
    __decorate([
        property({ type: Array, reflect: true, attribute: 'pvd-options' }),
        __metadata("design:type", Array)
    ], PvdSelect.prototype, "pvdOptions", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-required' }, PvdBaseComponent.booleanAttribute('pvd-required'))),
        __metadata("design:type", Boolean)
    ], PvdSelect.prototype, "pvdRequired", void 0);
    __decorate([
        property({
            type: String,
            reflect: true,
            attribute: 'pvd-selected-value',
        }),
        __metadata("design:type", String)
    ], PvdSelect.prototype, "pvdSelectedValue", void 0);
    __decorate([
        property(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdSelect.prototype, "pvdSize", void 0);
    return PvdSelect;
}(CustomElementMixin(ScopedElementsMixin(PvdBaseComponent))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

export { DEFAULT_DISABLED, DEFAULT_ERROR, DEFAULT_FULL_WIDTH, DEFAULT_REQUIRED, DEFAULT_SIZE, PvdSelect, SELECT_PROTECTED_ATTR_MAP };
